(function () {
  angular
    .module('BuscaAtivaEscolar')
    .config(function ($stateProvider) {
      $stateProvider.state('reports', {
        url: '/reports',
        templateUrl: '/views/reports/reports.html',
        controller: 'ReportViewerCtrl',
      });
    })
    .controller(
      'ReportViewerCtrl',
      function (
        $scope,
        $rootScope,
        moment,
        Platform,
        Modals,
        Utils,
        Cities,
        StaticData,
        Language,
        Reports,
        Identity,
        Charts,
        ngToast
      ) {
        $scope.identity = Identity;
        $scope.static = StaticData;
        $scope.lang = Language;
        $scope.ready = false;

        $scope.filters = {};
        $scope.entities = {};
        $scope.views = {};
        $scope.totals = {};
        $scope.fields = {};

        $scope.sort = 'maxToMin';

        $scope.reportData = {};

        $scope.current = {
          entity: 'children',
          dimension: 'cause',
          view: 'chart',
          date: {
            firstDate: new Date(),
            finalDate: new Date(),
          },
        };

        $scope.avaliable_graph = true;

        var someVarName = 1;
        localStorage.setItem('someVarKey', someVarName);
        //console.log('tste');
        $scope.selectedMenu = null;

        $scope.showGraph = function () {
          return $scope.avaliable_graph;
        };

        function onInit() {
          //----------------------------
          // Inicializa as datas para os datepickers
          $scope.today = function () {
            $scope.current.date.finalDate = new Date(); // Data final para hoje
            $scope.current.date.firstDate = new Date(); // Data inicial para hoje, para ajustar a seis meses atrás
            $scope.current.date.firstDate.setMonth(
              $scope.current.date.firstDate.getMonth() - 6
            ); // Subtrai 6 meses
          };

          $scope.popupStart = {
            opened: false,
          };

          $scope.popupFinish = {
            opened: false,
          };

          $scope.formatDates = 'ddMMyyyy';

          $scope.dateOptionsStart = {
            formatYear: 'yyyy',
            showWeeks: false,
            maxDate: new Date($scope.current.date.finalDate), // O máximo é a data final
          };

          $scope.dateOptionsFinish = {
            formatYear: 'yyyy',
            maxDate: new Date(),
            showWeeks: false,
          };

          $scope.openStartDate = function () {
            $scope.popupStart.opened = true;
          };

          $scope.openFinishDate = function () {
            $scope.popupFinish.opened = true;
          };
          //----------------------------

          $scope.ready = true;

          var lastWeek = moment().subtract(7, 'days').toDate();
          var today = moment().toDate();

          $scope.filters = {
            //case_status: ['in_progress', 'cancelled', 'completed', 'interrupted', 'transferred'],
            alert_status: ['accepted'],
            child_status: [
              'in_school',
              'in_observation',
              'out_of_school',
              'cancelled',
              'interrupted',
              'transferred',
            ],
            age: { from: 0, to: 2000 },
            age_ranges: ['0-3', '4-5', '6-10', '11-14', '15-17', '18'],
            age_null: true,
            //school_last_grade: null,
            //school_last_grade_null: true,
            //gender: Utils.pluck(StaticData.getGenders(), 'slug'), //['male', 'female', 'undefined'],
            //gender_null: true,
            //race: Utils.pluck(StaticData.getRaces(), 'slug'), //['male', 'female', 'undefined'],
            //race_null: true,
            //place_kind: ['rural', 'urban'],
            //place_kind_null: true
          };

          $scope.entities = {
            children: {
              id: 'children',
              name: 'Crianças e adolescentes',
              value: 'num_children',
              entity: 'children',
              dimensions: [
                'child_status',
                'step_slug',
                'age',
                'gender',
                'parents_income',
                'place_kind',
                'work_activity',
                'case_cause_ids',
                'alert_cause_id',
                'uf',
                'place_uf',
                'place_city_id',
                'city_id',
                'school_last_id',
                'race',
                'guardian_schooling',
                'country_region',
                'school_last_grade',
              ],
              filters: [
                // 'date',
                //'case_status',
                'child_status',
                'alert_status',
                //'age_ranges',
                //'gender',
                //'place_kind',
                //'school_last_grade',
                //'step_slug',
                'uf',
                'city',
                //'case_cause_ids'
              ],
              views: ['chart', 'timeline'],
            },
          };

          if (Identity.can('reports.tenants')) {
            $scope.entities.tenants = {
              id: 'tenants',
              name: 'Municípios participantes',
              value: 'num_tenants',
              entity: 'tenant',
              dimensions: ['uf', 'region'],
              filters: ['uf'],
              views: ['chart'],
            };
          }

          if (Identity.can('reports.ufs')) {
            $scope.entities.ufs = {
              id: 'ufs',
              name: 'Estados participantes',
              value: 'num_ufs',
              entity: 'uf',
              dimensions: ['uf', 'region'],
              filters: [],
              views: ['chart'],
            };
          }

          if (Identity.can('reports.signups')) {
            $scope.entities.signups = {
              id: 'signups',
              name: 'Adesões municipais',
              value: 'num_signups',
              entity: 'signup',
              dimensions: ['month'],
              filters: [],
              views: ['timeline'],
            };
          }

          $scope.views = {
            map: {
              id: 'map',
              name: 'Mapa',
              allowsDimension: false,
              viewMode: 'linear',
            },
            chart: {
              id: 'chart',
              name: 'Gráfico',
              allowsDimension: true,
              viewMode: 'linear',
            },
            timeline: {
              id: 'timeline',
              name: 'Linha do tempo',
              allowsDimension: true,
              viewMode: 'time_series',
            },
          };

          $scope.totals = {
            num_children: 'Número de crianças e adolescentes',
            num_tenants: 'Número de municípios participantes',
            num_ufs: 'Número de estados participantes',
            num_signups: 'Número de adesões municipais',
            num_alerts: 'Número de alertas',
            num_assignments: 'Número de casos sob sua responsabilidade',
          };

          $scope.fields = {
            // period: 'Período',
            //case_status: 'Status do caso',
            child_status: 'Status do caso',
            deadline_status: 'Status do andamento',
            alert_status: 'Status do alerta',
            step_slug: 'Etapa do caso',
            age: 'Faixa etária',
            age_ranges: 'Faixa etária',
            gender: 'Sexo',
            parents_income: 'Faixa de renda familiar',
            place_kind: 'Zona Rural/ Urbana',
            work_activity: 'Atividade econômica',
            case_cause_ids: 'Motivo do Caso',
            alert_cause_id: 'Motivo do Alerta',
            school_last_grade: 'Último ano cursado',
            user_group: 'Grupo do usuário',
            user_type: 'Tipo do usuário',
            assigned_user: 'Usuário responsável',
            parent_scholarity: 'Escolaridade do responsável',
            place_uf: 'UF da localização da criança',
            uf: 'UF da adesão',
            region: 'Região',
            city_id: 'Município da adesão',
            place_city_id: 'Município da localização da criança',
            school_last_id: 'Última escola que frequentou',
            city: 'Município da adesão',
            month: 'Mês',
            race: 'Raça / Etnia',
            guardian_schooling: 'Escolaridade do responsável',
            country_region: 'Região geográfica',
          };

          $scope.today();

          $scope.chartConfig = getChartConfig();

          $scope.refresh();
        }

        $scope.clearFilter = function (name) {
          $scope.filters[name] = null;
        };

        /**
         * * @param model
         * Marca e desmarca de forma sincronizada os campos cancelado e interrompido do filtro child_status e case_status
         */
        $scope.checkChild = function (model) {
          var i = _.findIndex($scope.filters.child_status, function (el) {
            return el === model;
          });
          if (i !== -1) {
            $scope.filters.child_status.splice(i, 1);
          } else {
            $scope.filters.child_status.push(model);
          }
        };

        $scope.refresh = function () {
          if ($scope.current.dimension !== 'alert_cause_id') {
            $scope.filters.alert_status = ['accepted'];
          }

          // Check if selected view is available in entity
          if (
            $scope.entities[$scope.current.entity].views.indexOf(
              $scope.current.view
            ) === -1
          ) {
            $scope.current.view = $scope.current.entity.views[0];
          }

          // Check if selected dimension is available in entity
          var availableDimensions =
            $scope.entities[$scope.current.entity].dimensions;
          if (availableDimensions.indexOf($scope.current.dimension) === -1) {
            $scope.current.dimension = availableDimensions[0];
          }

          fetchReportData().then(function (res) {
            if ($scope.current.view !== 'list') {
              $scope.chartConfig = getChartConfig();
            }

            //if response has property named 'tenant' set value to $scope.avaliable_graph
            if (res.response.hasOwnProperty('tenant')) {
              $scope.avaliable_graph = res.response.tenant;
              if ($scope.avaliable_graph == false)
                ngToast.danger(
                  'Este município ainda não fez adesão ao Busca Ativa Escolar!'
                );
            } else {
              $scope.avaliable_graph = true;
            }

            window.scrollTo(1, 1);
          });
        };

        /**
         * Função para permitir que os mapas sejam mudados.
         */

        $scope.exportXLS = function () {
          fetchReportData('xls').then(function (res) {
            Modals.show(
              Modals.DownloadLink(
                'Baixar arquivo XLS',
                'Clique no link abaixo para baixar o relatório exportado:',
                res.download_url
              )
            );
          });
        };

        /**
         * Função para gerar os gráficos com os filtros das datas e períodos.
         */

        function fetchReportData(format) {
          var params = Object.assign({}, $scope.current);
          params.view = $scope.views[$scope.current.view].viewMode;
          params.filters = $scope.filters;
          params.format = format ? format : 'json';
          var filter = localStorage.getItem('someVarKey');
          if (filter != '1') {
            if (filter !== 'filter') {
              if (params.view === 'linear') {
                delete $scope.filters.date;
                $scope.filters.created_at = {
                  gte: moment().subtract(filter, 'days').format('YYYY-MM-DD'),
                  lte: moment().format('YYYY-MM-DD'),
                  format: 'YYYY-MM-dd',
                };
              }

              if (params.view === 'time_series') {
                delete $scope.filters.created_at;
                $scope.filters.date = {
                  from: moment($scope.current.date.firstDate).format(
                    'YYYY-MM-DD'
                  ),
                  to: moment($scope.current.date.finalDate).format(
                    'YYYY-MM-DD'
                  ),
                  format: 'YYYY-MM-dd',
                };
              }

              if (filter === 'null') {
                if ($scope.filters.hasOwnProperty('created_at'))
                  delete $scope.filters.created_at;
                if ($scope.filters.hasOwnProperty('date'))
                  delete $scope.filters.date;
              }
            }
            if (filter === 'filter') {
              if ($scope.dt_inicial && $scope.dt_final) {
                if (params.view === 'time_series') {
                  delete $scope.filters.created_at;
                  $scope.filters.date = {
                    from: moment($scope.current.date.firstDate).format(
                      'YYYY-MM-DD'
                    ),
                    to: moment($scope.current.date.finalDate).format(
                      'YYYY-MM-DD'
                    ),
                    format: 'YYYY-MM-dd',
                  };
                }

                if (params.view === 'linear') {
                  delete $scope.filters.date;
                  $scope.filters.created_at = {
                    gte: moment($scope.current.date.firstDate).format(
                      'YYYY-MM-DD'
                    ),
                    lte: moment($scope.current.date.finalDate).format(
                      'YYYY-MM-DD'
                    ),
                    format: 'YYYY-MM-dd',
                  };
                }
              }
            }
          }

          params.filters.place_city_id = params.filters.place_city
            ? params.filters.place_city.id
            : null;

          if (params.view === 'time_series') {
            $scope.filters.date = {
              from: moment($scope.current.date.firstDate).format('YYYY-MM-DD'),
              to: moment($scope.current.date.finalDate).format('YYYY-MM-DD'),
              format: 'YYYY-MM-dd',
            };
            delete params.date;
          } else {
            delete params.date;
          }

          if (params.format === 'xls') {
            return Reports.query(params).$promise;
          }

          $scope.reportData = Reports.query(params);

          return $scope.reportData.$promise;
        }

        $scope.generateRandomNumber = function (min, max) {
          return min + Math.floor(Math.random() * (max - min));
        };

        $scope.isUFScoped = function () {
          return (
            Identity.getType() === 'gestor_estadual' ||
            Identity.getType() === 'supervisor_estadual'
          );
        };

        $scope.canFilterBy = function (filter_id) {
          if (!$scope.ready) return false;

          if (filter_id === 'date' && $scope.current.view !== 'timeline') {
            return false;
          }

          // Is filter valid for entity
          if (
            $scope.entities[$scope.current.entity].filters.indexOf(
              filter_id
            ) === -1
          ) {
            return false;
          }

          if (filter_id === 'uf') {
            return (
              Identity.getType() === 'gestor_nacional' ||
              Identity.getType() === 'superuser' ||
              Identity.getType() === 'visitante_nacional_1' ||
              Identity.getType() === 'visitante_nacional_2' ||
              Identity.getType() === 'visitante_nacional_3' ||
              Identity.getType() === 'visitante_nacional_4'
            );
          }

          if (filter_id === 'city') {
            return (
              Identity.getType() === 'gestor_nacional' ||
              Identity.getType() === 'superuser' ||
              Identity.getType() === 'gestor_estadual' ||
              Identity.getType() === 'coordenador_estadual' ||
              Identity.getType() === 'supervisor_estadual' ||
              Identity.getType() === 'visitante_nacional_1' ||
              Identity.getType() === 'visitante_nacional_2' ||
              Identity.getType() === 'visitante_nacional_3' ||
              Identity.getType() === 'visitante_nacional_4'
            );
          }

          return true;
        };

        $scope.fetchCities = function (query) {
          var data = { name: query, $hide_loading_feedback: true };
          if ($scope.filters.uf) data.uf = $scope.filters.uf;
          if ($scope.isUFScoped()) data.uf = Identity.getCurrentUser().uf;

          return Cities.search(data).$promise.then(function (res) {
            return res.results;
          });
        };

        $scope.renderSelectedCity = function (city) {
          if (!city) return '';
          return city.uf + ' / ' + city.name;
        };

        function getChartConfig() {
          if ($scope.current.view === 'chart')
            return generateDimensionChart(
              $scope.current.entity,
              $scope.current.dimension
            );
          if ($scope.current.view === 'timeline')
            return generateTimelineChart(
              $scope.current.entity,
              $scope.current.dimension
            );
          return {};
        }

        function generateDimensionChart(entity, dimension) {
          if (!$scope.ready) return false;
          if (!$scope.reportData) return;
          if (!$scope.reportData.$resolved) return;
          if (!$scope.reportData.response) return;
          if (!$scope.reportData.response.report) return;

          var report = $scope.reportData.response.report;
          var seriesName = $scope.reportData.response.seriesName
            ? $scope.reportData.response.seriesName
            : $scope.totals[$scope.entities[entity].value];
          var labels = $scope.reportData.labels ? $scope.reportData.labels : {};

          var sortable = [];
          var objSorted = {};
          var finalLabels = {};

          for (var value in report) {
            sortable.push([value, report[value]]);
          }

          if ($scope.sort == 'minToMax') {
            sortable.sort(function (a, b) {
              return a[1] - b[1];
            });
          }

          if ($scope.sort == 'maxToMin') {
            sortable.sort(function (a, b) {
              return b[1] - a[1];
            });
          }

          sortable.forEach(function (item) {
            objSorted['_' + item[0]] = item[1];
          });

          for (var key in labels) {
            finalLabels['_' + key] = labels[key];
          }

          return Charts.generateDimensionChart(
            objSorted,
            seriesName,
            finalLabels
          );
        }

        function generateTimelineChart(entity, dimension) {
          if (!$scope.ready) return false;

          if (!$scope.reportData) return;
          if (!$scope.reportData.$resolved) return;
          if (!$scope.reportData.response) return;
          if (!$scope.reportData.response.report) return;

          var report = $scope.reportData.response.report;
          var chartName = $scope.totals[$scope.entities[entity].value];
          var labels = $scope.reportData.labels ? $scope.reportData.labels : {};

          return Charts.generateTimelineChart(report, chartName, labels);
        }

        $scope.sumValuesOfReportData = function (object) {
          var final_value = 0;

          if (object !== undefined) {
            if (object.length !== 0) {
              for (const property in object) {
                final_value += object[property];
              }
            }
          }
          return final_value;
        };

        $scope.canShowLabel = function () {
          //can't show:
          var permissions = {
            gestor_nacional: ['school_last_id', 'place_city_id', 'city_id'],
            coordenador_operacional: ['uf', 'city_id'],
            gestor_politico: ['uf', 'city_id'],
            supervisor_institucional: ['uf', 'city_id'],
            gestor_estadual: ['place_uf'],
            coordenador_estadual: ['place_uf'],
            supervisor_estadual: ['place_uf'],

            visitante_nacional_1: [
              'school_last_id',
              'place_city_id',
              'city_id',
            ],
            visitante_nacional_2: [
              'school_last_id',
              'place_city_id',
              'city_id',
            ],
            visitante_nacional_3: [
              'school_last_id',
              'place_city_id',
              'city_id',
            ],
            visitante_nacional_4: [
              'school_last_id',
              'place_city_id',
              'city_id',
            ],

            visitante_estadual_1: ['place_uf'],
            visitante_estadual_2: ['place_uf'],
            visitante_estadual_3: ['place_uf'],
            visitante_estadual_4: ['place_uf'],
          };

          return function (item) {
            if (permissions[Identity.getCurrentUser().type].includes(item)) {
              return false;
            } else {
              return true;
            }
          };
        };

        $scope.filterShow = function () {
          $scope.showFilter = !$scope.showFilter;
        };

        /**
         * Funções abaixo servem para filtra as datas.
         */
        $scope.menuFilter = [
          { name: 'Tudo', title: 'Todos os registros', qtd_days: null },
          { name: 'Semanal', title: 'Ũltimos 7 dias', qtd_days: 7 },
          { name: 'Mensal', title: 'Últimos 30 dias', qtd_days: 30 },
          { name: 'Trimestral', title: 'Últimos 90 dias', qtd_days: 90 },
          { name: 'Semestral', title: 'Últimos 180 dias', qtd_days: 180 },
        ];

        $scope.fetchCausesData = function (value) {
          if (value === null || typeof value === 'number') {
            $scope.showFilter = false;
          }
          localStorage.setItem('someVarKey', value);
          $scope.selectedMenu = value;

          $scope.refresh();
        };

        //Date Picker and Masks

        $scope.today = function () {
          $scope.dt = new Date();
        };

        $scope.today();

        $scope.clear = function () {
          $scope.dt = null;
        };

        $scope.inlineOptions = {
          minDate: new Date(),
          showWeeks: false,
        };

        $scope.dateOptions1 = {
          formatYear: 'yyyy',
          showWeeks: false,
        };

        $scope.dateOptions2 = {
          formatYear: 'yyyy',
          maxDate: new Date(),
          showWeeks: false,
        };

        $scope.open1 = function () {
          $scope.popup1.opened = true;
        };

        $scope.open2 = function () {
          $scope.popup2.opened = true;
        };

        $scope.altInputFormats = ['M!/d!/yyyy'];

        $scope.popup1 = {
          opened: false,
        };

        $scope.popup2 = {
          opened: false,
        };

        $scope.refresByMinToMax = function () {
          $scope.sort = 'minToMax';
          $scope.refresh();
        };

        $scope.refresByMaxToMin = function () {
          $scope.sort = 'maxToMin';
          $scope.refresh();
        };

        Platform.whenReady(onInit); // Must be the last call, since $scope functions are not hoisted to the top
      }
    );
})();
